export default __webpack_public_path__ + "static/boat-2c85af7add65b67ab8d797d6eca5ac7b.png";